var map = {
	"./118970_Falkenberg_Energi_5_Tuffast-1.jpg": 3478,
	"./150611_Sundsvalls_kommun-1.jpg": 1244,
	"./20200211_Lidkoping.husguiden.feb-1.jpg": 3962,
	"./2663072_HP Rör_Värme_Bad_Värme-1.jpg": 3877,
	"./3277761_Elon Ljud_Bild_Falkenberg-1.jpg": 5188,
	"./3537869_XL_BYGG_Vårgårda-1.jpg": 3111,
	"./3553095_Optimalfönster-1.jpg": 6250,
	"./56779_Colorama_Tappers-1.jpg": 9003,
	"./635679_Siljansnäs_Eltjänst_Elon_Leksand-1.jpg": 650,
	"./701908_Sandberg-1.jpg": 926,
	"./98586_Svenssons-1.jpg": 8599,
	"./OLD_optimera.png": 75,
	"./OLD_optimera_lg.png": 3793,
	"./Reaxcer_Berg-1.jpg": 5551,
	"./bergvarme_solleftea.png": 8388,
	"./bergvarme_solleftea_lg.png": 3152,
	"./borjesskogs.jpg": 6407,
	"./edbergs_bygg.png": 772,
	"./edbergs_bygg_lg.png": 5728,
	"./eldabutiken.png": 3154,
	"./eldabutiken_lg.png": 8136,
	"./falkenberg_energi.png": 8353,
	"./farg1an.png": 9045,
	"./farg1an_lg.png": 8061,
	"./harmangers_plat.png": 6097,
	"./harmangers_plat_lg.png": 3630,
	"./kraftringen.png": 2650,
	"./kraftringen_lg.png": 9468,
	"./lefflers.png": 5197,
	"./lefflers_lg.png": 7754,
	"./optimera.png": 6506,
	"./optimera_lg.png": 5590,
	"./pireva.png": 7367,
	"./pireva_lg.png": 2384,
	"./reaxcer.png": 4982,
	"./reaxcer_lg.png": 9229,
	"./sandberg.png": 1656,
	"./sandberg_lg.png": 5488,
	"./small/carlsson.png": 1441,
	"./small/elbutiken.png": 7635,
	"./small/hj.png": 4553,
	"./small/mio.png": 9531,
	"./small/nk.png": 5140,
	"./small/svensson.png": 4512,
	"./small/wttech.png": 5652,
	"./sydpumpen.png": 7807,
	"./sydpumpen_lg.png": 697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3397;